import React from 'react'

import { Button, Grid } from '@mui/material'
import { useParams } from 'react-router-dom'

import { useCampaignReview, useUpdateCampaignReview } from 'hooks/useCampaignReview'
import { useCurrentUserId } from 'hooks/useCurrentUserId'

import DataReviewForm from './DataReviewForm'

type DataReviewProps = {
  next: (...args: any[]) => any
}

const DataReview = ({ next }: DataReviewProps) => {
  const { id } = useParams()
  const { data: info } = useCampaignReview(id)
  const userId = useCurrentUserId()
  const updateReview = useUpdateCampaignReview()

  const handleSubmit = async (values: any) => {
    await updateReview.mutateAsync({ id, payload: values }).catch(() => {})
    next()
  }

  const initialValues = {
    ...info,
    assignedUserId: info?.assignedUserId || userId,
    customer: {
      id: info?.customerId,
      name: info?.customer,
    },
  }

  return (
    <div>
      <Grid container spacing={2}>
        <Grid size={{ sm: 12 }}>
          <DataReviewForm initialValues={initialValues} onSubmit={handleSubmit} />
        </Grid>

        <Grid size={{ sm: 12 }}>
          <Button color="primary" disabled>
            Back
          </Button>
          <Button
            color="primary"
            form="campaignReview"
            loading={updateReview.isPending}
            type="submit"
            variant="contained">
            Save data
          </Button>
        </Grid>
      </Grid>
    </div>
  )
}

export default DataReview
